import { useTreatments } from '@maui-mf/root/splitio-react'

export const useFeatureFlag = (treatmentKey) => {
  const { [treatmentKey]: obj = {} } = useTreatments([treatmentKey])
  return obj.treatment === 'on'
}
